// The end of a hardware id as people read it out: its last six characters, in
// capitals. The id is base64url, so case would otherwise be one more thing to
// say aloud. The tablet's own screen and the service's messages show the same
// (`api/src/devices/support.ts`, `hardwareEnding`). Search ignores case, so
// typing it in capitals finds the device.
export const hardwareEnding = (hardwareId: string): string => hardwareId.slice(-6).toUpperCase();

/** How many characters the ending has; what comes before it is the rest of the id. */
export const ENDING_LENGTH = 6;
